import { render, staticRenderFns } from "./BooleanConsent.vue?vue&type=template&id=b9576b06&scoped=true&"
import script from "./BooleanConsent.vue?vue&type=script&lang=js&"
export * from "./BooleanConsent.vue?vue&type=script&lang=js&"
import style0 from "./BooleanConsent.vue?vue&type=style&index=0&id=b9576b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9576b06",
  null
  
)

export default component.exports